import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import queryString from 'query-string'
import { Col, Row } from 'react-bootstrap'
import { fetchReservedRegItems } from 'registry/actions'
import { ShippingDisclaimer } from 'store/components/landing-page/disclaimers'
import { CircularProgress } from '@material-ui/core'
import { categoryProps } from './reg-item-category/reg-item-category'
import GuestRegistryHeader from './guest-registry-header'
import RegItemCardGhostList from './reg-item-card-ghost'
import { RegItemsHeaderGuest } from './reg-items-headers/reg-items-header'
import { registryPageDataFetcher } from './registry-page-data-fetcher'
import RegItemCategoryList from './reg-item-category-list/reg-item-category-list'
import NoRegItemsMessage from './no-reg-items-message'
import ShippingAddressFab from './shipping-address-fab'
import { ReservedRegItemCategory } from './reserved-reg-item-category'

const RegistryPageGuest = ({
  addFilter,
  categorizedRegItems,
  favoriteRegItemsCount,
  fetchReservedRegItems,
  filteredRegItemsCount,
  filters,
  groupGiftsRegItemsCount,
  isAllCategoriesCollapsed,
  isPageReady,
  isShippingAddressButtonVisible,
  openContactInfoModal,
  openGiftTrackerModal,
  openMobileFiltersModal,
  regItemsCount,
  registry,
  reservationsByCurrentVisitor,
  reservedRegItems,
  reservedRegItemsByCurrentVisitor,
  setFilters,
  stores,
  showGiftTracker,
  isPartialSetOfRegItems,
}) => {
  const purchasedSectionRef = useRef()
  const scrollToPurchasedSection = (ref) =>
    window.scrollTo(0, ref.current.offsetTop)

  const maybeOpenGiftTrackerModal = () => {
    if (showGiftTracker && reservedRegItemsByCurrentVisitor.length > 0) {
      openGiftTrackerModal()
      scrollToPurchasedSection(purchasedSectionRef)
    }
  }

  useEffect(() => {
    if (isPageReady) {
      maybeOpenGiftTrackerModal()
      fetchReservedRegItems({ isGuestView: true })
    }
  }, [showGiftTracker, isPageReady])

  return (
    <>
      <GuestRegistryHeader />
      <div id="registry" className="container mtm mtl-sm pbxl">
        <Row className="flex col center">
          <Col xs={12}>
            <RegItemsHeaderGuest
              addFilter={addFilter}
              filters={filters}
              setFilters={setFilters}
              stores={stores}
              regItemsCount={regItemsCount}
              favoriteRegItemsCount={favoriteRegItemsCount}
              groupGiftsRegItemsCount={groupGiftsRegItemsCount}
              openMobileFiltersModal={openMobileFiltersModal}
            />
            <div className="reg-items">
              {isPageReady && (
                <NoRegItemsMessage
                  totalRegItemsCount={regItemsCount}
                  filteredRegItemsCount={filteredRegItemsCount}
                  clearFilters={setFilters}
                />
              )}

              <RegItemCategoryList
                filters={filters}
                reservationsByCurrentVisitor={reservationsByCurrentVisitor}
                reservedRegItemsByCurrentVisitor={
                  reservedRegItemsByCurrentVisitor
                }
                categories={categorizedRegItems}
                isAllCategoriesCollapsed={isAllCategoriesCollapsed}
              />

              {isPageReady &&
                (reservedRegItems || reservedRegItemsByCurrentVisitor) && (
                  <div ref={purchasedSectionRef}>
                    <ReservedRegItemCategory
                      reservations={reservedRegItems}
                      reservedRegItemsByCurrentVisitor={
                        reservationsByCurrentVisitor
                      }
                    />
                  </div>
                )}

              {!isPageReady &&
                (isPartialSetOfRegItems ? (
                  <Row className="flex col center mbxl mtl">
                    <Col className="mbm mtm">
                      <CircularProgress size={16} />
                      <span className="mlm">
                        Sit tight! Loading remaining items...
                      </span>
                    </Col>
                  </Row>
                ) : (
                  <RegItemCardGhostList />
                ))}
            </div>
          </Col>
        </Row>

        {isPageReady && (
          <ShippingAddressFab
            show={
              isShippingAddressButtonVisible &&
              !registry.isShippingAddressPrivate
            }
            firstNames={registry.firstNames}
            onClick={() => openContactInfoModal({ registry })}
          />
        )}
        <ShippingDisclaimer classname="mtm" />
      </div>
    </>
  )
}

RegistryPageGuest.propTypes = {
  regItemsCount: PropTypes.number.isRequired,
  favoriteRegItemsCount: PropTypes.number.isRequired,
  groupGiftsRegItemsCount: PropTypes.number.isRequired,
  addFilter: PropTypes.func.isRequired,
  setFilters: PropTypes.func.isRequired,
  fetchReservedRegItems: PropTypes.func.isRequired,
  filteredRegItemsCount: PropTypes.number.isRequired,
  categorizedRegItems: PropTypes.arrayOf(PropTypes.shape(categoryProps)),
  isAllCategoriesCollapsed: PropTypes.bool,
  isPageReady: PropTypes.bool,
  isPartialSetOfRegItems: PropTypes.bool,
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  reservationsByCurrentVisitor: PropTypes.object,
  reservedRegItems: PropTypes.array,
  reservedRegItemsByCurrentVisitor: PropTypes.array,
  openMobileFiltersModal: PropTypes.func.isRequired,
  openGiftTrackerModal: PropTypes.func.isRequired,
  filters: PropTypes.object,
  openContactInfoModal: PropTypes.func,
  isShippingAddressButtonVisible: PropTypes.bool,
  registry: PropTypes.object.isRequired,
  showGiftTracker: PropTypes.string,
}

RegistryPageGuest.defaultProps = {
  categorizedRegItems: [],
  filters: {},
  isAllCategoriesCollapsed: false,
  isPageReady: false,
  isPartialSetOfRegItems: false,
  reservedRegItems: [],
  reservationsByCurrentVisitor: {},
  reservedRegItemsByCurrentVisitor: [],
  stores: [],
  openContactInfoModal: () => {},
  isShippingAddressButtonVisible: false,
  showGiftTracker: false,
}

const mapStateToProps = (state, ownProps) => {
  const { showGiftTracker } = queryString.parse(ownProps.location.search)

  return {
    showGiftTracker,
  }
}

export default connect(mapStateToProps, { fetchReservedRegItems })(
  registryPageDataFetcher(RegistryPageGuest)
)
